<template>
    <div class="flex justify-center grid z-[90] place-items-center max-lg:h-[110vh] bg-slate-500/50 fixed items-center top-0 right-0 bottom-0 left-0">
        <div class="max-lg:w-[100%] float z-[100]  bg-white p-4 rounded-md w-[80vh] h-[35em] max-lg:h-2/4">
            <svg class="float-right mb-3 pt-0 w-11 h-11 hover:cursor-pointer" @click="$emit('close')" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#006e63">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg> 
            
            <iframe
            width="100%"
            height="80%" 
            frameborder="0" 
            :src="`https://www.google.com/maps/embed/v1/place?key=AIzaSyBOxvUnNFrTrzqtZ02NpvBbPLog1IQ7rnY&q=${local.local}&zoom=15`" allowfullscreen>
            </iframe>
        </div>
    </div>

</template>

<script>
    export default{
        computed:{
            local(){
                return this.$store.state.localSelecionado;
            }
        }
    }

</script>